<template>
  <div class="not-valid">
    <div class="row">
      <div class="col-8">
        <div v-if="hasContentInfos">
          <h4 v-html="NotValidTitle"></h4>
        </div>
        <div v-else>
          <h4>Lead Information</h4>
        </div>
        <div v-if="consumerErrors.length > 0">
          <div v-for="error in stringErrors" :key="error">
            {{error}}
          </div>
          <div v-if="hiddenFieldErrors.length > 0">
            <span class="fw-bold">Alert:</span> The value passed into the portal isn't accepted per the portal settings in leadHOOP.  Please review your settings and feel free to reach out to your leadHOOP representative.
            <br /><br />
            <div v-for="error in hiddenFieldErrors" :key="error.field">
              <div v-if="error.errorMsg && error.errorMsg.length > 0">
                <span class="fw-bold">{{error.field}}:</span> {{ error.errorMsg }}
              </div>
              <div v-else>
                <span class="fw-bold">Field:</span> {{error.field}}
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          Sorry, based on the information provided, this consumer does not qualify for any offers.
        </div>
        <br />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  name: 'NotValid',
  props: ['consumerId'],
  computed: {
    stringErrors () {
      return this.consumerErrors.filter((e) => typeof e === 'string')
    },
    hiddenFieldErrors () {
      return this.consumerErrors.filter((e) => typeof e !== 'string' && e.type === 'HiddenFieldError')
    },
    hasContentInfos () {
      return this.contentTextInfos.length > 0
    },
    NotValidTitle () {
      return this.mapText(this.contentTextInfos[0].invalid_page_title)
    },
    NotValidText () {
      return this.mapText(this.contentTextInfos[0].invalid_page_body)
    },
    ...mapState({
      loadedId: state => state.consumer.consumerId,
      consumerErrors: state => state.consumer.consumerErrors,
      contentTextInfos: state => state.consumer.contentTextInfos
    }),
    ...mapGetters({
      consumerLoaded: 'consumer/consumerLoaded',
      leadInfo: 'consumer/lead/leadInfo'
    })
  },
  methods: {
    load (id) {
      if (!this.consumerLoaded || this.loadedId !== id) {
        this.loadConsumer(id)
      }
    },
    mapText (text) {
      const leadFields = [['__consumer_phone__', 'phone1'],
        ['__consumer_name__', 'fullname'],
        ['__consumer_email__', 'email'],
        ['__consumer_firstname__', 'firstname'],
        ['__consumer_lastname__', 'lastname'],
        ['__agent_id__', 'agent_id'],
        ['__agent_name__', 'agent_name'],
        ['__call_center_dba__', 'call_center_dba'],
        ['__consumer_address__', 'address'],
        ['__consumer_city__', 'city'],
        ['__consumer_state__', 'state'],
        ['__consumer_zip__', 'zip']]

      if (this.leadInfo) {
        leadFields.forEach((item) => {
          text = text.replace(new RegExp(item[0], 'g'), this.leadInfo[item[1]] ?? '')
        })
      }
      return text
    },
    ...mapActions({
      loadConsumer: 'consumer/retrieveConsumer'
    })
  },
  mounted () {
    if (this.consumerId) {
      this.load(this.consumerId)
    }
  },
  watch: {
    consumerId (val) {
      this.load(val)
    }
  }
}
</script>
